import moveConversations from './moveConversations';
import moveItems from './moveItems';
import { listViewStore } from 'owa-mail-list-store';
import { ActionSource } from 'owa-analytics-actions';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';
import { action } from 'satcheljs/lib/legacy';

export default action('moveMailListRows')(async function moveMailListRows(
    rowKeys: string[],
    destinationFolderId: string,
    originalTableViewId: string,
    actionSource?: ActionSource
) {
    const originalTableView = listViewStore.tableViews.get(originalTableViewId);
    switch (originalTableView.tableQuery.listViewType) {
        case ReactListViewType.Conversation:
            await moveConversations(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;

        case ReactListViewType.Message:
            await moveItems(rowKeys, destinationFolderId, originalTableView, actionSource);
            break;
    }
});
